import React from 'react';
import { createPortal } from 'react-dom';

function Modal({ children, isOpen, onClose }) {
    const handleBackdropClick = (e) => {
        // Chỉ đóng khi click vào backdrop, không đóng khi click vào children
        if (onClose && e.target === e.currentTarget) {
            onClose();
        }
    };

    if (!isOpen) return null;

    return createPortal(
        <div
            className="fixed top-0 left-0 h-full w-full flex justify-center items-center z-50 backdrop-blur-md"
            onClick={handleBackdropClick}
        >
            {children}
        </div>,
        document.getElementById('portal')
    );
}

export default Modal;
